import { GraphQL } from '@guestgoodie/graphql'
import { Trans } from '@lingui/react/macro'

import * as Table from '@/components/ui/Table'

interface Props {
  sortDirection?: GraphQL.SortDirection | null
  sortField?: GraphQL.GoodiesSortField | null
  hideCheckbox: boolean
  onChangeSort: (
    field: GraphQL.GoodiesSortField,
    direction: GraphQL.SortDirection
  ) => void
}

export default function GoodieTableHead({
  sortDirection,
  sortField,
  hideCheckbox,
  onChangeSort
}: Props) {
  return (
    <Table.Head>
      <Table.Row>
        {!hideCheckbox && <Table.Heading />}
        <Table.SortableHeading<GraphQL.GoodiesSortField>
          sortField={GraphQL.GoodiesSortField.Name}
          currentSortDirection={sortDirection}
          currentSortField={sortField}
          onChangeSort={onChangeSort}
        >
          <Trans>Name</Trans>
        </Table.SortableHeading>
        <Table.Heading>
          <Trans>Information</Trans>
        </Table.Heading>
        <Table.Heading>
          <Trans>Price</Trans>
        </Table.Heading>
        <Table.SortableHeading<GraphQL.GoodiesSortField>
          sortField={GraphQL.GoodiesSortField.Type}
          currentSortDirection={sortDirection}
          currentSortField={sortField}
          onChangeSort={onChangeSort}
        >
          <Trans>Typ</Trans>
        </Table.SortableHeading>
        <Table.Heading />
      </Table.Row>
    </Table.Head>
  )
}
